export default "__VITE_ASSET__DOWuJHz$__"